import crypto from 'crypto'

// Non-UI constants (not user-facing strings)
const ALGO_SHA_256 = 'sha256'
const DIGEST_HEX = 'hex'

export function generateSHA256HashNode(inputString = '') {
  const hash = crypto.createHash(ALGO_SHA_256)
  hash.update(inputString)
  return hash.digest(DIGEST_HEX)
}
